module.exports = __webpack_public_path__ + "static/media/steps-icon.7e6f4c10.svg";